package team.platforma.aicombo.theme.colors

import androidx.compose.foundation.text.selection.TextSelectionColors
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color

@Composable
fun getOutlinedTextColors() = OutlinedTextFieldDefaults.colors().copy(
    focusedTextColor = AppColors.text().default,
    unfocusedTextColor = AppColors.text().disabled,
    focusedLabelColor = AppColors.text().primary,
    unfocusedLabelColor = AppColors.text().disabled,
    focusedContainerColor = Color.Transparent,
    unfocusedContainerColor = Color.Transparent,
    focusedIndicatorColor = AppColors.border().primary,
    cursorColor = AppColors.text().primary,
    textSelectionColors = TextSelectionColors(
        handleColor = AppColors.text().primary,
        backgroundColor = AppColors.text().primary
    )
)